import { render, staticRenderFns } from "./WidgetReadMenu.vue?vue&type=template&id=5db458ad&scoped=true"
import script from "./WidgetReadMenu.vue?vue&type=script&lang=js"
export * from "./WidgetReadMenu.vue?vue&type=script&lang=js"
import style0 from "./WidgetReadMenu.vue?vue&type=style&index=0&id=5db458ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db458ad",
  null
  
)

export default component.exports